
module.exports = {"attributes":{"width":"11","height":"10","viewBox":"0 0 11 10"},"content":"<path fill-rule=\"evenodd\" d=\"M5.5 0L11 10H0z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
